import axios from 'axios';

import { CommonSentiment } from 'common/comments2/Comments2.types';

export enum PromptDataType {
    Review = 1,
    Survey = 2,
    SocialPost = 3,
    SocialPostReply = 4,
    PrivateMessage = 5,
}

export interface GenerateSuggestedResponseRequest {
    promptText: string;
    sentiment: CommonSentiment;
    promptDataType: PromptDataType;
    originService: string;
    originID: string;
}

export const OriginService = {
    Comment2: 'r4e-comment-two',
    ReviewCore: 'r4e-review-core',
};

export const generateResponse = async (
    tenantId: number | undefined,
    params: GenerateSuggestedResponseRequest,
): Promise<string> => {
    const { data } = await axios.post<string>(`/api/tenants/${tenantId}/recommends/generate-response`, { ...params });

    return data;
};
